var React = require('react');

function BgSection1 (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("path",{"d":"M1366 0H0v438.42c96.46 137.49 262.57 228.26 451.31 228.26A574.47 574.47 0 00590 649.74c394.87-93.73 424.4-65.88 603.74 6.69A273.06 273.06 0 001366 666.89z","fill":"#4746d4","data-name":"Layer 1"})));
}

BgSection1.defaultProps = {"viewBox":"0 0 1366 676.11"};

module.exports = BgSection1;

BgSection1.default = BgSection1;
